/**
 * Foto del último tema aplicado en `:root`, para repintarlo en `index.html` antes del
 * primer fotograma de una recarga (el script `theme-preboot` la lee). Formato:
 * `{ v: 1, vars: { "--primary": "#...", ... } }`, con las variables tal como se
 * escribieron. Si cambia el formato, sube `v` en los dos lados.
 */
export const THEME_SNAPSHOT_KEY = "theme_css_snapshot";

/** Nunca lanza: sin almacenamiento disponible simplemente no hay foto. */
export function saveThemeSnapshot(vars: Record<string, string>): void {
	try {
		localStorage.setItem(THEME_SNAPSHOT_KEY, JSON.stringify({ v: 1, vars }));
	} catch (error) {
		// la foto es solo una mejora de arranque
	}
}

export function clearThemeSnapshot(): void {
	try {
		localStorage.removeItem(THEME_SNAPSHOT_KEY);
	} catch (error) {
		// idem
	}
}
